class CollectionBreadcrumb extends window.BAO.CustomElement() {
  connectedCallback () {
    if (!sessionStorage.getItem('BAO_Recent_Collection')) {
      this.parentElement.remove()
      return
    }
    const { collection } = JSON.parse(
      sessionStorage.getItem('BAO_Recent_Collection'),
    )

    this.parentElement.removeAttribute('aria-hidden')

    this.querySelector('a').href = collection.url
    this.querySelector('a').textContent = collection.name
  }
}

if (!customElements.get('collection-breadcrumb')) {
  customElements.define('collection-breadcrumb', CollectionBreadcrumb)
}
